module.exports = __webpack_public_path__ + "static/img/xingyunwu.fea9f38.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/xingyunwu.jpg
// module id = ywh3
// module chunks = 0